import { render, staticRenderFns } from "./SchoolClassSectionModal.vue?vue&type=template&id=6f6b280c&scoped=true&"
import script from "./SchoolClassSectionModal.vue?vue&type=script&lang=js&"
export * from "./SchoolClassSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b280c",
  null
  
)

export default component.exports